module.exports = __webpack_public_path__ + "media/images/result_sets/circles/3r2n6n9r-4683ff3e364ddbb5bb9bbf0ef6ab9f8f.svg";